import TrailheadMarker from './TrailheadMarker';

export default TrailheadMarker;
